import css from "./SimpleLink.module.css";

interface Props {
  href: string;
  isDark?: boolean;
  children: React.ReactNode;
  target?: React.HTMLAttributeAnchorTarget | undefined;
  rel?: string;
}

export default function SimpleLink({
  href,
  isDark = false,
  target = "_self",
  rel = "noreferrer",
  children,
}: Props) {
  return (
    <a
      href={href}
      target={target}
      rel={rel}
      className={isDark ? css["darkColor"] : css["color"]}
    >
      {children}
    </a>
  );
}
